import { updateCreditGuardData } from 'features/checkout/duck/actions'

export const operationProcessCreditGuardCheckoutResponse = (response) => (dispatch) => {
  const { extID, mpiHostedPageUrl } = response?.pageAttributes
  dispatch(updateCreditGuardData({ extID, mpiHostedPageUrl }))
}
